import React from "react";

/**
 * @component DiscussionIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <DiscussionIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DiscussionIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="DiscussionIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 11H5.17l-.59.59-.58.58V4h11v7zm0-9H4a2 2 0 00-2 2v13l4-4h9a2 2 0 002-2V4a2 2 0 00-2-2zm5 4h-1v6a3 3 0 01-3 3H6v1a2 2 0 002 2h10l4 4V8a2 2 0 00-2-2z"
      />
    </svg>
  )
);
DiscussionIcon.displayName = "DiscussionIcon";
export default DiscussionIcon;
